import type { Product, Variant } from 'app/src/services/welfareportal/companyagreement-api'
import type { Membership } from 'app/src/services/welfareportal/membership-api'
import type { TransferStatusValue } from 'app/src/services/welfareportal/moneytransfer-api'
import type { RefundStatusValue } from 'app/src/services/welfareportal/refund-api'
import type { OrderListQueryParams } from 'app/src/services/welfareportal/shopping-api'
export * as baseComponentApi from './basecomponent-api'
export * as catalogSummaryApi from './catalogsummary-api'
export * as companyagreementApi from './companyagreement-api'
export * as contactsApi from './contacts-api'
export * as documentAiApi from './document-ai-api'
export * as joinStepApi from './joinsteps-api'
export * as mealVouchersApi from './mealvouchers-api'
export * as mealVouchersAuthApi from './mealvouchers-auth-api'
export * as mealVouchersInternalApi from './mealvouchers-internal-api'
export * as membershipApi from './membership-api'
export * as moneytransferApi from './moneytransfer-api'
export * as newsApi from './news-api'
export * as pageconfigurationsApi from './pageconfigurations-api'
export * as partnersApi from './partners-api'
export * as portalConfigurationApi from './portalconfiguration-api'
export * as proposalsApi from './proposals-api'
export * as refundApi from './refund-api'
export * as shoppingApi from './shopping-api'
export * as tutorialsApi from './tutorials-api'
export * as welfareDetailsApi from './welfaredetails-api'

type UserFamilyMembers = Membership['userFamilyMembers']
type ArrayElementType<T extends unknown[] | undefined> = T extends (infer E)[] ? E : never
export type UserFamilyMember = ArrayElementType<UserFamilyMembers>

export type Relationship = UserFamilyMember['relationship']

export type ProductVariant = Variant
export type ProductTypology = Product['typology']

export const relationShipKeys = [
  'coniuge',
  'fratello_sorella',
  'figlio_figlia',
  'genero_nuora',
  'suocero_suocera',
  'genitore',
  'ascendente',
  'figlio_figlia_coniuge_deceduto',
  'discendente_prossimo',
] as const

// Helper function to create an enum from a union type
export function createEnum<T extends string>(o: Array<T>): { [K in T]: K } {
  return o.reduce((acc, curr) => {
    acc[curr] = curr
    return acc
  }, Object.create(null))
}

/**
 * @export
 * @namespace PrivacyDocument
 */
export namespace PrivacyDocument {
  /**
   * @export
   * @enum {string}
   */
  export enum StatusEnum {
    Created = 'created',
    Uploaded = 'uploaded',
  }
}

export type PrivacyDocument = {
  documentId: string
  documentName: string
  status: PrivacyDocument.StatusEnum
  urlPath: string
}

export type OrderListSortKind = OrderListQueryParams['sort']
export type OrderListStatusFilter = OrderListQueryParams['status']
export type OrderListStatus = ArrayElementType<OrderListStatusFilter>

export interface StatusConfigType {
  key: string
  label: string
}
/*
export const directStatusList: StatusConfigType[] = [
  {
    key: 'confirmed',
    label: 'Emesso'
  },
  {
    key: 'used',
    label: 'Utilizzato'
  },
  {
    key: 'submitted',
    label: 'Inviato'
  },
  {
    key: 'refused',
    label: 'Rifiutato'
  },
  {
    key: 'approved',
    label: 'Approvato'
  }
]
*/

export type RefundStatus = RefundStatusValue
/*
export const RefundStatusList: StatusConfigType[] = [
  {
    key: 'SUBMITTED' as RefundStatusValue,
    label: 'Ricevuto'
  },
  {
    key: 'INPROGRESS' as RefundStatusValue,
    label: 'In lavorazione'
  },
  {
    key: 'REJECTED' as RefundStatusValue,
    label: 'Rifiutato'
  },
  {
    key: 'CANCELED' as RefundStatusValue,
    label: 'Annullato'
  },
  {
    key: 'REFUNDED' as RefundStatusValue,
    label: 'Approvato'
  }
]
*/
export type TransferStatus = TransferStatusValue
/*
export const transferStatusList: StatusConfigType[] = [
  {
    key: 'SUBMITTED' as TransferStatusValue,
    label: 'Inviato'
  },
  {
    key: 'CONFIRMED' as TransferStatusValue,
    label: 'Eseguito'
  },
  {
    key: 'REJECTED' as TransferStatusValue,
    label: 'Rifiutato'
  }
]
  */

/**
 * @export
 * @namespace Variant
 */
// export namespace ProductVariant {
/**
 * @export
 * @enum {string}
 */
export enum TargetPersonEnum {
  Employee = 'employee',
  FamilyMember = 'familyMember',
  All = 'all',
  AllAndAdultWithPrivacy = 'allAndAdultWithPrivacy',
  FamilyMemberDependent = 'familyMemberDependent',
  DependentChildrenAndSpouse = 'dependentChildrenAndSpouse',
  EmployeeAndFamilyMemberDependent = 'employeeAndFamilyMemberDependent',
}
export type TargetPersonEnumType = TargetPersonEnum

export enum RelationshipEnum {
  Coniuge = 'coniuge',
  FratelloSorella = 'fratello_sorella',
  FiglioFiglia = 'figlio_figlia',
  GeneroNuora = 'genero_nuora',
  SuoceroSuocera = 'suocero_suocera',
  Genitore = 'genitore',
}
export enum ProductTypologyEnum {
  MoneyTransfer = 'moneyTransfer',
  Refund = 'refund',
  GiftCard = 'giftCard',
  GoodAndService = 'goodAndService',
  Pass = 'pass',
  Voucher = 'voucher',
}

export enum TransferStatusValueEnum {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}

declare global {
  interface Window {
    customFetch: typeof window.fetch
  }
}
